import tinkerbell from 'tinkerbell'

/*******************************************************************************************************************************************/
/* Zelektor
/*******************************************************************************************************************************************/
// <div class="js-item"></div>
// const { item } = zelektor(node)
// const { item: items } = zelektor(node)

// <div class="js-item"></div>
// <div class="js-element"></div>
// const { item, element } = zelektor(node)
// const { item: items, element: elements } = zelektor(node)

// <div class="prefix-item"></div>
// const { item } = zelektor(node, 'prefix')

export function zelektor(container = document.body, prefix = 'js-') {
    let elements = [].slice.call(container.querySelectorAll(`[class*="${prefix}"]`))

    return elements.reduce((res, el) => {
        ;[].slice.call(el.classList).forEach((className) => {
            if (className.slice(0, prefix.length) === prefix) {
                const key = className.slice(prefix.length, className.length)

                res[key] = res.hasOwnProperty(key)
                    ? res[key].constructor === Array
                        ? res[key].concat(el)
                        : [res[key], el]
                    : el
            }
        })
        return res
    }, {})
}

/*******************************************************************************************************************************************/
/* Loopify 
/*******************************************************************************************************************************************/
export function loopify(el) {
    const array = el ? [].concat(el) : []
    return array
}

/*******************************************************************************************************************************************/
/* Fix/Unfix Root
/*******************************************************************************************************************************************/
export function fixRoot(fixedClass = 'is-fixed') {
    const docEl = document.documentElement
    const scrollPos =
        docEl.style.top && docEl.style.top != ''
            ? parseInt(docEl.style.top.replace('-', '').replace('px', ''))
            : window.scrollY

    docEl.classList.add(fixedClass)

    docEl.style.position = 'fixed'
    docEl.style.width = '100%'
    docEl.style.overflowY = 'scroll'
    docEl.style.top = `-${scrollPos}px`

    docEl.dataset.scrollPos = scrollPos
}

export function unfixRoot(fixedClass = 'is-fixed') {
    const docEl = document.documentElement

    docEl.classList.remove(fixedClass)

    docEl.style.position = ''
    docEl.style.width = ''
    docEl.style.overflowY = ''
    docEl.style.top = ''

    const scrollPos = docEl.dataset.scrollPos
    window.scrollTo(0, scrollPos)
}

export function toggleFixRoot(fixedClass = 'is-fixed') {
    const docEl = document.documentElement

    docEl.classList.contains('is-fixed') ? unfixRoot(fixedClass) : fixRoot(fixedClass)
}

/*******************************************************************************************************************************************/
/* Toggle Display
/*******************************************************************************************************************************************/
export function toggleDisplay(el) {
    el.style.display === 'none' ? (el.style.display = '') : (el.style.display = 'none')
}

/*******************************************************************************************************************************************/
/* Toggle Button
/*******************************************************************************************************************************************/
export function toggleBtn(btn, isDisabled, text) {
    isDisabled ? btn.classList.add('is-disabled') : btn.classList.remove('is-disabled')
    if (text) btn.innerText = text
}

/*******************************************************************************************************************************************/
/* Disable Button
/*******************************************************************************************************************************************/
export function disableBtn(btn) {
    btn.disabled = true
    btn.classList.add('is-disabled')
}

/*******************************************************************************************************************************************/
/* Enable Button
/*******************************************************************************************************************************************/
export function enableBtn(btn) {
    btn.disabled = false
    btn.classList.remove('is-disabled')
}

/*******************************************************************************************************************************************/
/* Remove Section
/*******************************************************************************************************************************************/
export function removeSection(section) {
    section.parentNode.removeChild(node)
}

/*******************************************************************************************************************************************/
/* Set/Get Cookie
/*******************************************************************************************************************************************/
export function setCookie(name, value, days) {
    var expires = ''
    if (days) {
        var date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function getCookie(name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
}

/*******************************************************************************************************************************************/
/* Clear Inputs
/*******************************************************************************************************************************************/
export function clearInputs(parent) {
    parent.querySelectorAll('input').forEach((elem) => {
        elem.value = ''
    })

    parent.querySelectorAll('select').forEach((elem) => {
        if (elem.options[0]) elem.value = elem.options[0].value
    })
}

/*******************************************************************************************************************************************/
/* Shuffle Array
/*******************************************************************************************************************************************/
export function shuffleArray(array) {
    let index = array.length,
        tempVal,
        random

    // While there remain elements to shuffle...
    while (0 !== index) {
        // Pick a remaining element...
        random = Math.floor(Math.random() * index)
        index -= 1

        // And swap it with the current element.
        tempVal = array[index]
        array[index] = array[random]
        array[random] = tempVal
    }

    return array
}

/*******************************************************************************************************************************************/
/* Sort By Array
/*******************************************************************************************************************************************/
export function sortByArray(array, orderArray, key) {
    const clonedArray = [...array]
    return clonedArray.sort((a, b) => {
        if (orderArray.indexOf(a[key]) > orderArray.indexOf(b[key])) {
            return 1
        } else {
            return -1
        }
    })
}

/*******************************************************************************************************************************************/
/* Get Product Card HTML
/*******************************************************************************************************************************************/
import { formatMoney } from '@/lib/currency.js'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { format } from 'prettier'

export function getProductCardHTML({ product, middleMan }) {
    const v = product.variants[0]

    const prices = product.variants.map((item) => item.price)
    const priceMin = Math.min(...prices)
    const priceMax = Math.max(...prices)

    let imgSrc
    if (middleMan) {
        imgSrc = product.image
            ? getSizedImageUrl(product.image.src.replace('.' + imageSize(product.image.src), ''), '720x')
            : ''
    } else {
        if (product.featured_image) {
            imgSrc = product.featured_image
                ? getSizedImageUrl(product.featured_image.replace('.' + imageSize(product.featured_image), ''), '720x')
                : ''
        } else {
            imgSrc = product.images[0]?.src
                ? getSizedImageUrl(product.images[0].src.replace('.' + imageSize(product.images[0].src), ''), '720x')
                : ''
        }
    }

    const imgSrcLazy =
        'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII='

    const comparePrice =
        v.compare_at_price && v.compare_at_price != '' && v.compare_at_price != '0.00'
            ? formatMoney(parseFloat(v.compare_at_price) * (middleMan ? 100 : 1))
            : ''
    const badgeContent = getBadgeContent()
    const productSizes = getProductSizes()

    const productUrl = middleMan ? `https://${Shopify.shop}/products/${product.handle}` : product.url

    function getBadgeContent() {
        let content = ''
        if (parseFloat(v.compare_at_price) > parseFloat(v.price)) {
            const savePercent = Math.floor(
                100 - (parseFloat(v.price) / parseFloat(v.compare_at_price)) * (middleMan ? 100 : 1)
            )
            content = `
                        ${window.theme.templates.scissors}
                        <span>-${savePercent}%</span>
                        `
        }

        // We can only check for availability when using the endpoints where that is available
        if (
            !product.variants.find((v) => {
                if (v.hasOwnProperty('available') && !v.available) {
                    return false
                } else {
                    return true
                }
            })
        ) {
            content = window.theme.strings.product.soldOut
        }

        return content
    }

    function getProductSizes() {
        const option = product.options.find((o) => o.name === 'size' || o.name === 'Size')
        const optionPos = option ? option.position : null
        const validOptions = [
            ...new Set(
                product.variants.filter((v) => v.inventory_quantity > 0).map((variant) => variant[`option${optionPos}`])
            ),
        ]
        const truncate = validOptions.length > 5 ? ', ...' : ''
        const sizes = optionPos ? validOptions.slice(0, 5).join(', ') + truncate : ''
        return sizes
    }

    let productCard = theme.templates.productCard
        .replace('%imgSrc%', imgSrc)
        .replace('%imgSrcLazy%', imgSrcLazy)
        .replace('%badgeContent%', badgeContent)
        .replace('%productVendor%', product.vendor)
        .replace('%productTitle%', product.title)
        .replace('%minPrice%', formatMoney(parseFloat(priceMin) * (middleMan ? 100 : 1)))
        .replace('%maxPrice%', formatMoney(parseFloat(priceMax) * (middleMan ? 100 : 1)))
        .replace('%comparePrice%', comparePrice)
        .replace('%price%', formatMoney(parseFloat(v.price) * (middleMan ? 100 : 1)))
        .replace('%productUrl%', productUrl)
        .replace('%productSizes%', productSizes)
        .replace('%id%', product.id)

    if (priceMin == priceMax) {
        productCard = productCard.replace('js-minPrice', 'is-hidden')
    } else {
        productCard = productCard.replace('js-currentPrice', 'is-hidden')
    }

    if (comparePrice != '')
        productCard = productCard.replace('price--current', 'price--current price--current--highlight')

    return productCard
}

/*******************************************************************************************************************************************/
/* Render Product Card
/*******************************************************************************************************************************************/
// The optional wrapper argument should be an object containing an element type + optional class(es)
// E.g.: { elementType: 'div', className: 'product-card__wrapper' }
export function renderProductCard({ product, parentEl, wrapper, middleMan }) {
    const html = getProductCardHTML({ product, middleMan })
    const productCard = document.createElement('div')

    if (wrapper) {
        const wrapperEl = document.createElement(wrapper.elementType)
        if (wrapper.className) {
            const classes = wrapper.className.split(' ')
            classes.forEach((c) => wrapperEl.classList.add(c))
        }
        wrapperEl.appendChild(productCard)
        parentEl.appendChild(wrapperEl)
    } else {
        parentEl.appendChild(productCard)
    }

    productCard.outerHTML = html
}

/*******************************************************************************************************************************************/
/* Smooth Scroll
/*******************************************************************************************************************************************/
export function smoothScroll(target, options = {}) {
    if (!target) return

    const end = getOffset(target) + (options.offset || 0)
    const duration = options.duration || 500
    const element = options.element || window

    function getOffset(node) {
        return node.getBoundingClientRect().top + window.pageYOffset
    }

    return duration
        ? tinkerbell(
              !options.element || options.element === window ? element.pageYOffset : element.scrollTop,
              end,
              duration,
              (t, b, c, d) => {
                  if ((t /= d / 2) < 1) return (c / 2) * t * t + b
                  return (-c / 2) * (--t * (t - 2) - 1) + b
              }
          )((p) => element.scrollTo(0, p))
        : element.scrollTo(0, end)
}

/*******************************************************************************************************************************************/
/* Debounce
/*******************************************************************************************************************************************/
export function debounce(func, wait, immediate) {
    var timeout
    return function () {
        var context = this,
            args = arguments
        var later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        var callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}
